import React from "react";
import { Check, X } from "lucide-react";

export default function CellRenderer({ column, value, isEditable }) {
  const renderValue = () => {
    // Handle null/undefined
    if (value === null || value === undefined) {
      return <span className="text-gray-400 italic">-</span>;
    }

    switch (column.data_type) {
      case "text":
        return <span className="text-gray-900">{value}</span>;

      case "number":
      case "double":
        return (
          <span className="text-gray-900 font-mono">
            {typeof value === "number" ? value.toLocaleString() : value}
          </span>
        );

      case "date":
        if (!value) return <span className="text-gray-400 italic">-</span>;
        try {
          const date = new Date(value);
          return (
            <span className="text-gray-900">
              {date.toLocaleDateString("ko-KR")}
            </span>
          );
        } catch {
          return <span className="text-gray-900">{value}</span>;
        }

      case "datetime":
        if (!value) return <span className="text-gray-400 italic">-</span>;
        try {
          const date = new Date(value);
          return (
            <span className="text-gray-900">
              {date.toLocaleDateString("ko-KR")}{" "}
              {date.toLocaleTimeString("ko-KR", {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
          );
        } catch {
          return <span className="text-gray-900">{value}</span>;
        }

      case "boolean":
        return (
          <div className="flex items-center">
            {value ? (
              <div className="flex items-center gap-1 text-green-600">
                <Check className="w-4 h-4" />
                <span className="text-sm">예</span>
              </div>
            ) : (
              <div className="flex items-center gap-1 text-gray-400">
                <X className="w-4 h-4" />
                <span className="text-sm">아니오</span>
              </div>
            )}
          </div>
        );

      case "select":
        if (!value) return <span className="text-gray-400 italic">-</span>;
        return (
          <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
            {value}
          </span>
        );

      default:
        return <span className="text-gray-900">{String(value)}</span>;
    }
  };

  return <div className={`${isEditable ? "group" : ""}`}>{renderValue()}</div>;
}
